
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Card, CardContent } from '../../components/ui/card';
import DocumentUploader from './DocumentUploader';
import { DocumentType } from '../../types/dataRoom';

const CompanyDocuments: React.FC = () => {
  const companyDocumentTypes = [
    {
      id: 'financials',
      label: 'Financials',
      documentTypes: [
        'audited_financials_2022_23',
        'audited_financials_2023_24', 
        'audited_financials_2024_25',
        'provisional_financials',
        'mis_financials',
        'ITR'
      ] as DocumentType[],
    },
    {
      id: 'banking',
      label: 'Banking',
      documentTypes: ['bank_statements', 'gst_filing','Sanction Letter'] as DocumentType[],
    },
    {
      id: 'kyc',
      label: 'KYC Documents',
      documentTypes: ['company_kyc', 'director_kyc', 'company_deck'] as DocumentType[],
    },
    {
      id: 'other',
      label: 'Other',
      documentTypes: ['other','Asset Leasing'] as DocumentType[],
    },
  ];

  return (
    <div className="max-w-5xl mx-auto">
      <Card className="border-dataroom-primary/20 shadow-lg">
        <CardContent className="p-4">
          <Tabs defaultValue="financials">
            <TabsList className="w-full bg-dataroom-primary-light">
              {companyDocumentTypes.map((type) => (
                <TabsTrigger 
                  key={type.id} 
                  value={type.id} 
                  className="flex-1 data-[state=active]:bg-dataroom-primary data-[state=active]:text-white"
                >
                  {type.label}
                </TabsTrigger>
              ))}
            </TabsList>
            
            {companyDocumentTypes.map((type) => (
              <TabsContent key={type.id} value={type.id}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 max-w-4xl mx-auto">
                  {type.id === 'financials' && (
                    <>
                      <DocumentUploader
                        allowedTypes={['audited_financials_2022_23']}
                        label="Audited Financials 2022-23"
                      />
                      <DocumentUploader
                        allowedTypes={['audited_financials_2023_24']}
                        label="Audited Financials 2023-24"
                      />
                      <DocumentUploader
                        allowedTypes={['audited_financials_2024_25']}
                        label="Audited Financials 2024-25"
                      />
                      <DocumentUploader
                        allowedTypes={['provisional_financials']}
                        label="Provisional"
                      />
                      <DocumentUploader
                        allowedTypes={['mis_financials']}
                        label="MIS"
                      />
                      <DocumentUploader
                        allowedTypes={['itr']}
                        label="ITR"
                      />
                    </>
                  )}
                  
                  {type.id === 'banking' && (
                    <>
                      <DocumentUploader
                        allowedTypes={['bank_statements']}
                        label="Bank Statements"
                      />
                      <DocumentUploader
                        allowedTypes={['gst_filing']}
                        label="GST Filing"
                      />
                      <DocumentUploader
                        allowedTypes={['sanction_letter']}
                        label="Sanction Letter"
                      />
                    </>
                  )}
                  
                  {type.id === 'kyc' && (
                    <>
                      <DocumentUploader
                        allowedTypes={['company_kyc']}
                        label="Company KYC Documents"
                      />
                      <DocumentUploader
                        allowedTypes={['director_kyc']}
                        label="Director KYC Documents"
                      />
                      <DocumentUploader
                        allowedTypes={['company_deck']}
                        label="Company Deck"
                      />
                    </>
                  )}
                  
                  {type.id === 'other' && (
                    <>
                    <DocumentUploader
                      allowedTypes={['other']}
                      label="Other Documents"
                    />
                    <DocumentUploader
                      allowedTypes={['asset_leasing']}
                      label="Asset Leasing"
                    />
                    </>
                    
                  )}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompanyDocuments;
